import styled from "styled-components";

export const StyledBox = styled.div`
    padding: 20px;
    border-radius: 12px;
    background: orange;
    color: #333;
    font-size: 1.1rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    overflow: auto;
    word-wrap: break-word;
    font-family: BMJUA,serif;
`;

export const StyledInput = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    textarea {
        padding: 12px;
        border: transparent;
        border-radius: 8px;
        font-size: 1rem;
        outline: none;
        resize: none;
        font-family: BMJUA,serif;
    }
`;
